import Spinner from '../assets/Spinner';

export default function Loading() {
  return (
    <>
      <div id='bf-chat-window-loading'>
        <div className='wrapper'>
          <div className='row'>
            <div className='col'>
              <div className='loading'>
                <div className='loading-indicator'></div>
                <p>
                  Loading... <Spinner />
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
